class AdminMenuController {

    constructor($rootScope, permissionsService, access, integrationService) {
        this.$rootScope = $rootScope;
        this.user = permissionsService.user;
        this.access = access;
        this.integrationService = integrationService;
    }

    hasIntegration () {
        return this.integrationService.hasIntegration();
    }

    hasLinkedIntegration () {
        return this.integrationService.hasLinkedIntegration();
    }

    isNonRevspa () {
        return this.integrationService.isNonRevspa();
    }
}

AdminMenuController.$inject = ['$rootScope', 'permissionsService', 'access', 'integrationService'];

export default AdminMenuController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/base/controllers/admin.menu.controller.js